<template>
  <router-link
  :to="{ name: 'home', params: { tourId: this.tour.id }, query: { ...this.$route.query } }"
  style="text-decoration: none; color: inherit; cursor: pointer;"
>
    <div class="flex flex-1 min-h-[6em] mx-2 my-2">
      <div :class="`flex h-28 w-28 relative overflow-hidden bg-gray-200 ${params.preview ? ' rounded-l-lg' : 'rounded-lg'}`">
        <img 
          v-if="tour?.main_picture?.preview_url"
          :class="`object-cover h-full w-full`" 
          :alt="showMultiLingualText(tour?.introduction_title, null, true)" 
          :src="tour?.main_picture?.preview_url" 
        />
      </div>

      <div class="flex flex-1 flex-col px-3 overflow-hidden justify-between">
        <div>
          <div>
            <p class="text-sm font-bold line-clamp-2">
              {{ showMultiLingualText(tour?.introduction_title, null, true) }}
            </p>
          </div>

          <p class="text-sm line-clamp-4 pt-1">
            {{ showMultiLingualText(tour?.introduction_text, null, true) }}
          </p>
        </div>
      </div>

      <div class="flex items-center p-2">
        <ChevronRightIcon class="w-5 h-5 text-gray-400" />
      </div>
    </div>
  </router-link>
</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/24/outline'
import { mapActions } from 'vuex'

export default {
  name: 'TourListItem',
  components: {
    ChevronRightIcon
  },
  props: {
    tour: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {

    showMultiLingualText(text, altText = null, showFirstLanguage = false) {
      function isObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value)
      }

      if (isObject(text)) {
        if (this.$i18n.locale in text && text[this.$i18n.locale]) {
          return String(text[this.$i18n.locale])
        }

        if (altText) {
          return String(altText)
        }

        if (showFirstLanguage) {
          const firstKey = Object.keys(text)[0]
          if (text[firstKey]) {
            return String(text[firstKey])
          }
        }

        return ""
      }

      return (altText) ? String(altText) : (text ? String(text) : "")
    }
  }
}
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-4 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style> 